import { IconProps } from "./Icons";

export const IconImage = ({
  width = 24,
  height = 24,
  color = "#0B3E5F",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <rect x="3.75" y="4.5" width="16.5" height="15" rx="1.5" stroke={color} strokeWidth="1.8" />
    <circle cx="9" cy="10" r="1.5" fill={color} />
    <path
      d="M4.5 18L10.125 12.375L13.125 15.375L15.375 13.125L19.5 17.25"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
